module.exports = __webpack_public_path__ + "static/media/Immobilier-Expertise-Vaud.67f5db8a.jpg";